// extracted by mini-css-extract-plugin
module.exports = {"blockContainer":"EJdd16","backgroundImage":"xrKPub","labels":"bPWYOz","label":"nYgAH_","sublabel":"gqN8Zo","proLogo":"E9-4SI","arrowContainer":"CeSTyc"};